import { dropzoneHtml } from "../../Utils/Dropzone/Dropzone";
import { uniqueRandomId } from "../save/SaveUtils";


export function openInsertImageModal(insert:Function, args={}){

    const content = '';

    const submitBtn = {}

    const id = uniqueRandomId(3);

    const exists = document.getElementById("add-image-to-sth-" + id) !== null;

    const modal = makeModal("add-image-to-sth-" + id, "Datei hochladen", content, submitBtn, true, 'sm', false);

    const modalHtml = $("#add-image-to-sth-" + id);
    modalHtml.find(".fast-faq").remove();
    modalHtml.find(".modal-title").append('<span class="fast-faq ms-3" onclick="showQuestion('+ 13 + ');"><i class="fa fa-question-circle"></i></span>')

    if (!exists){
        const html = dropzoneHtml('add-image-to-sth-' + id);
        $("#add-image-to-sth-" + id).find(".modal-body").after(html);
        const dropzone = addDropzone(insert, true, id, args);
    }
    modal.show();
}

export function showInsertImage(insert:Function, holder:string){

    const id = uniqueRandomId(3);

    const html = dropzoneHtml('add-image-to-sth-' + id);
    $(holder).html(html);

    const args = {}
    addDropzone(insert, false, id, args);

}


function addDropzone(insert:Function, modal = false, id='1', args={}){
const dropzone = new Dropzone('form#add-image-to-sth-' + id, {
    maxFilesize: 5,
    autoQueue: true,
    acceptedFiles: ".png,.jpeg,.jpg,.PNG,.JPEG,.JPG",
    uploadMultiple: false,
    parallelUploads: 1,
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    init: function(){
        const dz = this;
        dz.on("complete", function(file){
            
        })
        dz.on("success", function(file, response){
            
            hideSpinner($(".upload-info"));
            
                const url = response.path;
                if (modal){
                    hideModal("add-image-to-sth-" + id);
                }
                insert(url, args);




        })
        dz.on("error", function(one, two){
            errorToast("Konnte nicht hochgeladen werden");
        })
    },     
    addedfile: function(file){
        const btn = $(".upload-info");
        showSpinner(btn);
    },

})
return dropzone;
}